import { createContext } from 'react';
import size from '../constants/size';
const GlobalContext = createContext({
  gridConfig: {},
  maxWidth: size.contentMaxWidth
});
export default GlobalContext;
//# sourceMappingURL=GlobalContext.js.map